import LookDetail from '../lookDetailDialog/LookDetail';
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Vue from "vue";
Vue.use(Viewer)
Viewer.setDefaults({
    Options: {
        'inline': true,
        'button': true,
        'navbar': true,
        'title': true,
        'toolbar': true,
        'tooltip': true,
        'movable': true,
        'zoomable': true,
        'rotatable': true,
        'scalable': true,
        'transition': true,
        'fullscreen': true,
        'keyboard': true,
        'url': 'data-source'
    }
})
LookDetail.install = (Vue)=>{
    Vue.components(LookDetail.name,LookDetail)
}
export  default LookDetail
